import { Component } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-verify-email",
  templateUrl: "./verify-email.component.html",
  styleUrls: ["./verify-email.component.css"],
})
export class VerifyEmailComponent {
  emailId: string = "";
  key: string | null = null;
  userId: any;
  ifLinkExpired: boolean = false;
  status: any;
  constructor(
    private CommonService: CommonService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private routing: Router,
  ) {
    this.route.queryParamMap.subscribe((params) => {
      const normalizedParams: any = {};
      params.keys.forEach((k) => {
        normalizedParams[k.toLowerCase()] = params.get(k);
      });
      this.key = normalizedParams["key"];
      this.status = normalizedParams["status"];

      if (this.key) {
        try {
          let key = atob(this.key);
          this.userId = key.split("/")[0]; // decode base64 → userid
          if (this.status) {
            this.updateVerification();
          } else {
            this.verifyEmail();
          }
          // console.log("Decrypted USER_ID:", this.userId);
        } catch (err) {
          // console.error("Invalid key format", err);
        }
      }
    });
  }

  validateEmail(event: any) {
    let val = event.target.value;
    let exp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    if (new RegExp(exp).test(val)) {
      let parts = val.split("@");
      if (parts.length === 2 && /\d/.test(parts[1])) {
        this.emailId = "";
        this.toastr.warning('Numbers are not allowed after "@"');
        return;
      } else {
        this.emailId = val;
      }
    } else {
      this.emailId = "";
      this.toastr.warning(
        "Invalid email credentials, please enter a valid email",
      );
    }
  }

  verifyEmail() {
    // if (!this.emailId) {
    //   return this.toastr.warning("Please enter emailid");
    // }

    if (!this.userId) {
      return this.toastr.error("Invalid or missing user ID in link");
    }

    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `Registration/GetRoleIdByUserId/${this.userId}`,
    ).subscribe(async (res: any) => {
      const encryptedRoleId = await this.CommonService.encryptAesGcm(
        res.roleid.toString(),
        this.CommonService.key,
      );
      this.CommonService.postCall("Registration/EmailVerified", {
        // UserName: this.emailId,
        ROLEIDS: encryptedRoleId,
        USER_ID: this.userId, // ✅ send decoded ID
      }).subscribe(
        (res: any) => {
          this.toastr.success(res.message);
          if (res.message == "Link Expired") {
            (window as any)["$"]("#linkExpiredModal").modal("show");
            this.ifLinkExpired = true;
          }
          this.emailId = "";
          this.CommonService.deactivateSpinner();
          (window as any)["$"]("#successModal").modal("show");
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.CommonService.deactivateSpinner();
        },
      );
    });
  }

  // continueToLogin() {
  //   $<any>("#successModal").modal("hide");
  //   this.routing.navigate(["/login"]);
  // }

  continueToLogin() {
    const modal = $<any>("#successModal");

    modal.one("hidden.bs.modal", () => {
      this.routing.navigate(["/login"]);
    });

    modal.modal("hide");
  }

  updateVerification() {
    if (!this.userId) return;

    this.CommonService.activateSpinner();
    this.CommonService.postCall("Registration/UpdateVerificationDate", {
      USER_ID: this.userId,
    }).subscribe(
      (res: any) => {
        // (window as any)["$"]("#linkExpiredModal").modal("show");
        $("linkExpiredModal").modal("show");
        this.toastr.success("Verification email sent successfully");
        this.routing.navigate(["/login"]);

        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.CommonService.deactivateSpinner();
      },
    );
  }
}
